import { MiningEnergy } from "../models/miningenergy.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getMiningEnergySum = (group_id: number): Promise<MiningEnergy[]> => {
    return new Promise<MiningEnergy[]>((resolve, reject) => {
        if(!group_id) return;
        
        responseHero.get(`${process.env.REACT_APP_API_URL}/miningEnergySum/${group_id}`).then((response) => {
            resolve(response.data as MiningEnergy[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};